export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20deep%20red%20lighting%2C%20abstract%20floating%20film%20strips%20and%20stars%20in%20dark%20space%2C%20artistic%20composition%20with%20soft%20bokeh%20and%20lens%20flares%2C%20elegant%20entertainment%20concept%20art%2C%20luxurious%20cinematic%20aesthetic%2C%20dark%20moody%20background%20with%20warm%20accents&width=1600&height=900&seq=hero-bg-movie-01&orientation=landscape"
          alt="91影视看片下载 - 免费高清影视平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-400/30 mb-5">
              <i className="ri-star-fill text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-accent-300 text-sm font-medium whitespace-nowrap">天美麻花星空影视免费观看</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              91影视看片下载
              <br />
              <span className="text-accent-300">免费高清影视大全追剧平台</span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-light mb-3 whitespace-nowrap">
              每日更新 · 高清不缓冲 · 全网资源一站收录
            </p>

            <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              91影视看片下载整合海量电影、电视剧、综艺、动漫资源，覆盖动作、喜剧、科幻、悬疑等全类型内容。天美麻花星空影视免费观看专区每日同步更新，高清画质流畅播放不缓冲。无论是最新热播剧集还是经典高分电影，在免费影视大全追剧平台都能一站找到，让您畅享极致的免费追剧体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <div className="text-accent-300 font-heading text-lg font-bold">20万+</div>
                  <div className="text-white/55 text-xs">影视资源覆盖</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <div className="text-accent-300 font-heading text-lg font-bold">每日更新</div>
                  <div className="text-white/55 text-xs">追剧日历同步</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <div className="text-accent-300 font-heading text-lg font-bold">高清流畅</div>
                  <div className="text-white/55 text-xs">多线路自动切换</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base whitespace-nowrap transition-all duration-200 cursor-pointer text-center inline-block"
              >
                立即探索热门影视
                <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/25 rounded-full text-base font-medium whitespace-nowrap transition-all duration-200 cursor-pointer text-center inline-block"
              >
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20collage%20with%20golden%20film%20reels%20and%20warm%20spotlight%20effects%2C%20elegant%20movie%20aesthetic%20with%20dark%20theater%20curtains%2C%20floating%20popcorn%20and%20stars%2C%20luxurious%20entertainment%20visual%20art%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20sophisticated%20cinematic%20composition&width=600&height=700&seq=hero-visual-movie-02&orientation=portrait"
                alt="91影视看片下载 - 影视主题视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}